import {
  AssociateCompanyParamsTypes,
  ParamsTypes,
  LargeShareholderTypes,
  OwnershipStructuresTypes,
  LeaderListParamsTypes,
  CompaniesTypes,
} from './types';

import axiosInstance from 'services/common/instance';

export const getAssociateCompanyService = async (
  params?: AssociateCompanyParamsTypes,
) => {
  const res = await axiosInstance.get('ttpt-company-associations', { params });
  return res.data.data;
};

export const getLargeShareholderService = async (
  params: ParamsTypes,
): Promise<PaginationData<LargeShareholderTypes[]>> => {
  const response = await axiosInstance.get('ttpt-large-shareholders', {
    params,
  });
  return response.data;
};

export const getOwnershipStructuresService = async (
  params: ParamsTypes,
): Promise<OwnershipStructuresTypes[]> => {
  const response = await axiosInstance.get('ttpt-ownership-structures', {
    params,
  });
  return response.data.data;
};

export const getLeaderListService = async (params: LeaderListParamsTypes) => {
  const res = await axiosInstance.get('ttpt-key-officers', { params });
  return res.data.data;
};

export const getCompaniesService = async (
  params?: ParamsTypes,
): Promise<CompaniesTypes[]> => {
  const res = await axiosInstance.get('ttpt-companies', { params });
  return res.data.data;
};
